<p>book-details-entry-point works!</p>
